export enum AdminAnswersTableColumnTitle {
  OrdinalNumber = "Redni broj",
  Answer = "Odgovor",
  Tip = "Uputa uz odgovor",
  Options = "",
}
